import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreatePartNotesController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
import { quillModules, quillFormats, addToolbarTitles } from "../../../Common/quillConfig";
import SunTextEditor from "../../../Common/SunTextEditor";
function CreatePartNotes({ modalInstance, currentNotes, onClose, onSuccess, StockID }) {


    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const [formData, setFormData] = useState({ ID: 0, StockID: StockID, Notes: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (currentNotes) {
            setFormData({
                ...formData,
                ID: currentNotes.ID, StockID: currentNotes.StockID, Notes: currentNotes.Notes

            });
        } else {
            setFormData({
                ...formData,
                ID: 0, StockID: StockID, Notes: ''
            });
        }
    }, [currentNotes]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            Notes: content
        });
    };
    const handleFormSubmit = async (event) => {
        debugger;
        event.preventDefault();

        if (currentNotes) {
            formData.ID = currentNotes.ID;
        } else {
            formData.ID = 0;
        }

        const message = await handleSubmit(event, formData, setFormData, setErrors);
        debugger;
        if (message === "User added successfully") {
            onSuccess();
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerHistoryModal show d-block" id="customerHistoryModal" tabIndex="-1" aria-labelledby="customerHistoryModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentNotes ? "Edit Notes" : "Add Notes"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginLeft: "-5px",marginTop:"10px",marginRight:"0px" }}>
                                        <div className="col-sm-12">
                                            <table style={{ width: "100%" }}>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ width: "13%" }}>
                                                            <label htmlFor="Notes" style={{ float: "right" }}>Notes <span style={{ "color": "red" }}>*</span></label>
                                                        </td>
                                                        <td colSpan={3}>
                                                            <SunTextEditor
                                                                value={formData.Notes}
                                                                onChange={(content) =>
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        Notes: content,
                                                                    }))
                                                                }
                                                            />
                                                            {errors.Notes && <div style={{ color: 'red' }}>{errors.Notes}</div>}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                       <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                                            {currentNotes ? " Update" : " Save"}
                                       
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreatePartNotes;
